// TV Shows card game data - ranked by episode count + cultural impact
export const TV_SHOWS_CARDS = [
  { id: 1, name: "The Simpsons", rank: 1, image: "/images/tvShows/tvShows_1.jpg" },
  { id: 2, name: "Grey's Anatomy", rank: 2, image: "/images/tvShows/tvShows_2.jpg" },
  { id: 3, name: "Law & Order: SVU", rank: 3, image: "/images/tvShows/tvShows_3.jpg" },
  { id: 4, name: "NCIS", rank: 4, image: "/images/tvShows/tvShows_4.jpg" },
  { id: 5, name: "Family Guy", rank: 5, image: "/images/tvShows/tvShows_5.jpg" },
  { id: 6, name: "South Park", rank: 6, image: "/images/tvShows/tvShows_6.jpg" },
  { id: 7, name: "Criminal Minds", rank: 7, image: "/images/tvShows/tvShows_7.jpg" },
  { id: 8, name: "Supernatural", rank: 8, image: "/images/tvShows/tvShows_8.jpg" },
  { id: 9, name: "ER", rank: 9, image: "/images/tvShows/tvShows_9.jpg" },
  { id: 10, name: "Seinfeld", rank: 10, image: "/images/tvShows/tvShows_10.jpg" },
  { id: 11, name: "Friends", rank: 11, image: "/images/tvShows/tvShows_11.jpg" },
  { id: 12, name: "The Office", rank: 12, image: "/images/tvShows/tvShows_12.jpg" },
  { id: 13, name: "Game of Thrones", rank: 13, image: "/images/tvShows/tvShows_13.jpg" },
  { id: 14, name: "Breaking Bad", rank: 14, image: "/images/tvShows/tvShows_14.jpg" },
  { id: 15, name: "Cheers", rank: 15, image: "/images/tvShows/tvShows_15.jpg" },
  { id: 16, name: "M*A*S*H", rank: 16, image: "/images/tvShows/tvShows_16.jpg" },
  { id: 17, name: "House", rank: 17, image: "/images/tvShows/tvShows_17.jpg" },
  { id: 18, name: "The Walking Dead", rank: 18, image: "/images/tvShows/tvShows_18.jpg" },
  { id: 19, name: "How I Met Your Mother", rank: 19, image: "/images/tvShows/tvShows_19.jpg" },
  { id: 20, name: "Parks and Recreation", rank: 20, image: "/images/tvShows/tvShows_20.jpg" },
  { id: 21, name: "Frasier", rank: 21, image: "/images/tvShows/tvShows_21.jpg" },
  { id: 22, name: "CSI", rank: 22, image: "/images/tvShows/tvShows_22.jpg" },
  { id: 23, name: "Two and a Half Men", rank: 23, image: "/images/tvShows/tvShows_23.jpg" },
  { id: 24, name: "The Big Bang Theory", rank: 24, image: "/images/tvShows/tvShows_24.jpg" },
  { id: 25, name: "Modern Family", rank: 25, image: "/images/tvShows/tvShows_25.jpg" },
  { id: 26, name: "New Girl", rank: 26, image: "/images/tvShows/tvShows_26.jpg" },
  { id: 27, name: "Smallville", rank: 27, image: "/images/tvShows/tvShows_27.jpg" },
  { id: 28, name: "The X-Files", rank: 28, image: "/images/tvShows/tvShows_28.jpg" },
  { id: 29, name: "Lost", rank: 29, image: "/images/tvShows/tvShows_29.jpg" },
  { id: 30, name: "Stranger Things", rank: 30, image: "/images/tvShows/tvShows_30.jpg" }
];
